import { Switch as HeadlessSwitch } from "@headlessui/react";

/*
 * The switch in the Tixora template's look (HeroUI v3, styles/controls.css .switch) on our
 * tokens, owner 2026-10-11; Headless UI keeps the keyboard and the switch role. The Core 2
 * kit's dark glass switch it replaces had no accessible name or disabled state.
 */
type SwitchProps = {
    className?: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    /** Accessible name when no visible label sits beside it. */
    ariaLabel?: string;
    disabled?: boolean;
};

const Switch = ({ className, checked, onChange, ariaLabel, disabled }: SwitchProps) => (
    <HeadlessSwitch
        className={`switch ${className || ""}`}
        checked={checked}
        onChange={onChange}
        aria-label={ariaLabel}
        disabled={disabled}
    >
        <span className="switch__control">
            <span className="switch__thumb" />
        </span>
    </HeadlessSwitch>
);

export default Switch;
